import { commonFormFields, useCurrencyData } from '@routable/shared';
import useFieldValue from 'hooks/useFieldValue';
export const useFormSelectedCurrency = (formName) => {
    const selectedCurrencyCode = useFieldValue(formName, commonFormFields.CURRENCY_CODE);
    const { data } = useCurrencyData();
    return {
        name: data?.[selectedCurrencyCode]?.name,
        code: selectedCurrencyCode,
    };
};
